module.exports = __webpack_public_path__ + "static/media/s.357beb4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/terrains/s.png
// module id = 515
// module chunks = 0